import { reactive } from 'vue';
const calendarWidgetState = reactive({
    start: '',
    end: '',
    locationId: '',
    userId: '',
    calendarId: '',
    userIds: [],
    calendarIds: [],
    groupIds: [],
    timezone: '',
    events: [],
    activeView: 'user',
    filterValue: 'All',
    refreshEvents: 1,
    viewAppointmentModal: {
        show: false,
        data: {},
    },
    bookAppointmentVisible: false,
    bookAppointmentCalendarId: '',
    bookAppointmentUsingDrag: false,
    bookAppointmentModal: {
        show: false,
        data: {},
        isBlockedSlot: false,
        startTime: '',
        endTime: '',
    },
    isCalendarLoading: true,
    startDayOfWeek: 0,
    resourceDragData: {
        type: '',
        id: '',
        isActive: false,
    },
});
export default calendarWidgetState;
